import {
  FETCH_CATEGORY_SHOWCASES_PENDING,
  FETCH_CATEGORY_SHOWCASES_FULFILLED,
  FETCH_CATEGORY_SHOWCASES_REJECTED,
  FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_PENDING,
  FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_FULFILLED,
  FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_REJECTED,
} from "../actions/categoryShowcase";

const initialState = {
  categoryShowcases: [],
  currentShowcase: null,
  loading: false,
  error: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CATEGORY_SHOWCASES_PENDING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CATEGORY_SHOWCASES_FULFILLED:
      return {
        ...state,
        categoryShowcases: payload || [],
        loading: false,
        error: null,
      };

    case FETCH_CATEGORY_SHOWCASES_REJECTED:
      return {
        ...state,
        loading: false,
        error: payload,
        categoryShowcases: [],
      };

    case FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_PENDING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_FULFILLED:
      return {
        ...state,
        currentShowcase: payload,
        loading: false,
        error: null,
      };

    case FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_REJECTED:
      return {
        ...state,
        loading: false,
        error: payload,
        currentShowcase: null,
      };

    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/store/reducers/categoryShowcaseReducer.js